import {
  RankingSystem,
  WorldUniversityRankingRange,
  WorldSubjectRankingRange,
  DisciplineRankingSystem,
  NationalRankingSystem,
} from '../../../../DRCAssessment/components/constants';
import { PAGE_TEXT } from '../../../../lang';
import type { SelectOption } from '../../../../../../components';

export const worldUniversityRankingOptions: SelectOption[] = [
  {
    label: RankingSystem.QS,
    value: RankingSystem.QS,
  },
  {
    label: RankingSystem.THE,
    value: RankingSystem.THE,
  },
  {
    label: RankingSystem.ARWU,
    value: RankingSystem.ARWU,
  },
];

const NATIONAL_RANKING =
  PAGE_TEXT.DRC_ASSESSMENT_DETAILS.ASSESSMENT.STEP_A.NATIONAL_RANKING;
export const NationalRankingOptions: SelectOption[] = [
  {
    label: NATIONAL_RANKING.FIRST_TIER,
    value: NationalRankingSystem.FIRST_TIER,
  },
  {
    label: NATIONAL_RANKING.SECOND_TIER,
    value: NationalRankingSystem.SECOND_TIER,
  },
];

const WOLRD_UNIVERSITY_RANKING =
  PAGE_TEXT.DRC_ASSESSMENT_DETAILS.ASSESSMENT.STEP_A.WOLRD_UNIVERSITY_RANKING;
export const worldUniversityRankingRangeOptions: SelectOption[] = [
  {
    label: WOLRD_UNIVERSITY_RANKING.TOP_1_TO_50,
    value: WorldUniversityRankingRange.TOP_1_TO_50,
  },
  {
    label: WOLRD_UNIVERSITY_RANKING.TOP_51_TO_100,
    value: WorldUniversityRankingRange.TOP_51_TO_100,
  },
  {
    label: WOLRD_UNIVERSITY_RANKING.TOP_101_TO_200,
    value: WorldUniversityRankingRange.TOP_101_TO_200,
  },
  {
    label: WOLRD_UNIVERSITY_RANKING.TOP_201_TO_300,
    value: WorldUniversityRankingRange.TOP_201_TO_300,
  },
  {
    label: WOLRD_UNIVERSITY_RANKING.TOP_301_TO_400,
    value: WorldUniversityRankingRange.TOP_301_TO_400,
  },
  {
    label: WOLRD_UNIVERSITY_RANKING.TOP_401_TO_500,
    value: WorldUniversityRankingRange.TOP_401_TO_500,
  },
];

const WOLRD_SUBJECT_RANKING =
  PAGE_TEXT.DRC_ASSESSMENT_DETAILS.ASSESSMENT.STEP_A.WOLRD_SUBJECT_RANKING;
export const worldSubjectRankingRangeOptions: SelectOption[] = [
  {
    label: WOLRD_SUBJECT_RANKING.TOP_1_TO_20,
    value: WorldSubjectRankingRange.TOP_1_TO_20,
  },
  {
    label: WOLRD_SUBJECT_RANKING.TOP_21_TO_50,
    value: WorldSubjectRankingRange.TOP_21_TO_50,
  },
  {
    label: WOLRD_SUBJECT_RANKING.TOP_51_TO_75,
    value: WorldSubjectRankingRange.TOP_51_TO_75,
  },
  {
    label: WOLRD_SUBJECT_RANKING.TOP_76_TO_100,
    value: WorldSubjectRankingRange.TOP_76_TO_100,
  },
  {
    label: WOLRD_SUBJECT_RANKING.TOP_101_TO_150,
    value: WorldSubjectRankingRange.TOP_101_TO_150,
  },
];

const RANKING_LINKS =
  PAGE_TEXT.DRC_ASSESSMENT_DETAILS.ASSESSMENT.STEP_A.RANKING_LINKS;
export const rankingLinks = [
  {
    name: RANKING_LINKS.QS.NAME,
    url: RANKING_LINKS.QS.URL,
  },
  { name: RANKING_LINKS.ARWU.NAME, url: RANKING_LINKS.ARWU.URL },
  {
    name: RANKING_LINKS.TIMES.NAME,
    url: RANKING_LINKS.TIMES.URL,
  },
];

export const disciplineRankingOptions: SelectOption[] = [
  {
    label: DisciplineRankingSystem.UL1,
    value: DisciplineRankingSystem.UL1,
  },
  {
    label: DisciplineRankingSystem.UL2,
    value: DisciplineRankingSystem.UL2,
  },
  {
    label: DisciplineRankingSystem.UL3,
    value: DisciplineRankingSystem.UL3,
  },
  {
    label: DisciplineRankingSystem.UL4,
    value: DisciplineRankingSystem.UL4,
  },
  {
    label: DisciplineRankingSystem.UL5,
    value: DisciplineRankingSystem.UL5,
  },
];
